import { FC, useEffect, useState } from "react"
import { InputSwitch } from "primereact/inputswitch";
import './truck.css'
import ReactApexChart from "react-apexcharts";
import { STATE_ENTREGAS_INITIAL_STATE } from "../../../data/constants";
import { TrucksTable } from "./TrucksTable/TrucksTable";

export const Trucks:FC<any> = (props):JSX.Element => {

    const {trucks, trucksMASTER, setTrucks, setTrucksMASTER, changesFlag, setChangesFlag, id, flagChangeScenario, setFlagChangeScenario, tabID} = props

    
    return (
        <div className="entregas__wrapper" style={{justifyContent:'center'}}>
            
            <TrucksTable
                data={trucks}
                setData={setTrucks}
                dataMASTER={trucksMASTER}
                setDataMASTER={setTrucksMASTER}
                changesFlag={changesFlag}
                setChangesFlag={setChangesFlag}
                flagChangeScenario={flagChangeScenario}
                setFlagChangeScenario={setFlagChangeScenario}
                id={id}
                tabID={tabID} 
                />   
        </div>
    )
}